import { IcShoplChatLogo, IcChatLogoWhite } from '@/assets/icons';
import LanguageSelect from '@/components/login/LanguageSelect';
import * as SC from '@/pages/login/LoginPage.style';
import useThemeStore from '@/stores/themeStore';
import LoginForm from '@/views/Login/LoginForm';

const LoginPage = () => {
  const { theme } = useThemeStore();

  return (
    <SC.Wrapper>
      {/* 언어 선택 */}
      <LanguageSelect />
      <SC.LoginBox>
        <SC.LoginBoxSignboard>{theme === 'dark' ? <IcChatLogoWhite /> : <IcShoplChatLogo />}</SC.LoginBoxSignboard>
        {/* 로그인 */}
        <LoginForm />
      </SC.LoginBox>
    </SC.Wrapper>
  );
};

export default LoginPage;
